module.exports = __webpack_public_path__ + "img/myposition_wm_모하메드 살라.1316d912.png";